const LoadGoogleMaps = (apiKey, libraries = []) => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps && window.google.maps.ControlPosition) {
      resolve();
      return;
    }

    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`
    );
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        if (window.google && window.google.maps && window.google.maps.ControlPosition) {
          resolve();
        } else {
          reject(new Error('Google Maps API not fully available after script load'));
        }
      });
      existingScript.addEventListener('error', () => {
        reject(new Error('Error loading existing Google Maps API script'));
      });
      return;
    }

    window.initMap = () => {
      if (window.google && window.google.maps && window.google.maps.ControlPosition) {
        resolve();
      } else {
        reject(new Error('Google Maps API not fully available after initMap'));
      }
    };

    const libraryParam =
      libraries.length > 0 ? `&libraries=${libraries.join(',')}` : '';
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}${libraryParam}&callback=initMap&loading=async`;
    script.async = true;
    script.defer = true;
    script.addEventListener('error', () => {
      reject(new Error('Failed to load Google Maps API script'));
    });
    document.head.appendChild(script);
  });
};

export default LoadGoogleMaps;
